/* eslint-disable no-nested-ternary */
import { shallowEqual, useSelector } from "react-redux";
import SectionHeader from "../SectionHeader/SectionHeader";
import { AppState } from "@Store/index";
import DefaultCompactInventoryCard from "@Pages/Home/components/HomepageCollectionSkeleton/DefaultCompactInventoryCard";
import styles from "./featuredAccomodations.module.scss";
import HorizontalScroll from "@Components/HorizontalScroll";
import { useEffect, useState } from "react";
import fetchFeaturedAccomodations from "./data/fetchFeaturedAccomodations";
import CompactInventoryCard from "@Components/CompactInventoryCard";
import { PAGE } from "constants/configConstants";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import useTranslationHook from "hooks/useTranslationHook";
import useWhitelabel from "hooks/useWhitelabel";
import { useResponsiveness } from "hooks/useResponsiveness";

type FeaturedAccommodationProps = {
  isDesktop?: boolean;
};
const FeaturedAccomodations = ({ isDesktop: isDesktopProp }: FeaturedAccommodationProps) => {
  const { isAbove } = useResponsiveness();
  const isDesktop = isDesktopProp ?? isAbove("md");
  const { region, userCurrency } = useSelector(
    ({ searchPageData, appData }: AppState) => ({
      region: searchPageData.region,
      userCurrency: appData.userCurrency,
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();

  const isUSA =
    region?.location?.country?.long_name === "United States" ||
    region?.location?.country?.long_name === "Canada";
  const [featuredAccomodations, setFeaturedAccomodations] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getFeaturedAccomodtions = async (currentRegion: any) => {
    setLoading(true);
    const data = await fetchFeaturedAccomodations({
      isCountry: currentRegion?.region_type === "country",
      region: currentRegion,
      isWhitelabel,
      userCurrency,
    });
    setFeaturedAccomodations(data);
    setLoading(false);
  };

  useEffect(() => {
    if (region?.id) {
      getFeaturedAccomodtions(region);
    }
  }, [region?.id]);

  return (
    <div
      className={formatClassNames(
        styles.sectionContainer,
        isDesktop && styles.desktopSectionContainer,
      )}
    >
      <SectionHeader
        title={`${t(
          "searchpage.components.sectionregionelements.components.featuredaccommodation.featuredstudent",
        )} ${
          isUSA
            ? t(
                "searchpage.components.sectionregionelements.components.featuredaccommodation.housingtext",
              )
            : t(
                "searchpage.components.sectionregionelements.components.featuredaccommodation.accommodationtext",
              )
        } ${t(
          "searchpage.components.sectionregionelements.components.featuredaccommodation.intext",
        )} ${region.name}`}
        isDesktop={isDesktop}
        titleClassName={styles.noMarginRight}
      />
      {loading ? (
        <HorizontalScroll
          className={formatClassNames(styles.horizontalScrollCr, isDesktop && styles.desktopCr)}
        >
          {Array.from({ length: 10 }, (_, index) => index + 1).map((ele) => (
            <DefaultCompactInventoryCard key={ele} />
          ))}
        </HorizontalScroll>
      ) : featuredAccomodations.length > 0 ? (
        <HorizontalScroll
          className={formatClassNames(styles.horizontalScrollCr, isDesktop && styles.desktopCr)}
          showControls={isDesktop}
        >
          {featuredAccomodations.map((item: any) => (
            <CompactInventoryCard
              item={item}
              key={item?.id}
              isRequestActive={loading}
              showIcons
              showDistanceRails
              gtagEventAction="inventory_clicked"
              gtagEventCategory={PAGE.SEARCH}
              screenName={APP_PAGE.SEARCH}
              className={styles.inventoryCard}
            />
          ))}
        </HorizontalScroll>
      ) : (
        <div className={styles.emptyResult}>
          {t(
            "searchpage.components.sectionregionelements.components.featuredaccommodation.nofeaturedinventories",
          )}
        </div>
      )}
      {!isDesktop && <div className={styles.bottomBorder} />}
    </div>
  );
};

export default wrapperHOC(FeaturedAccomodations, {
  componentName: "FeaturedAccomodations-SectionRegionElements-SearchPage",
  showForChina: true,
});
